<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting certifications...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-card>
          <v-layout class="px-2">
          <v-flex shrink class="mr-1">
            <v-switch
              v-model="onlyExpiredDos"
              label="Expired Dosimetry badge"
              >
            </v-switch>
            <v-switch
              v-model="onlyExpiredCert"
              label="Expired certifications"
              >
            </v-switch>
          </v-flex>
          </v-layout>
        <v-data-table
          :items="filteredReport"
          :headers="headers"
          item-key="worksite_id"
          class="elevation-1"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                <router-link :to="{ name: 'employee/certifications', params: { employeeId: item.employee.id } }" target="_blank">
                  {{ item.employee.first_name }}
                  {{ item.employee.last_name }}
                </router-link>
              </td>
              <td>
                <ul class="unstyled">
                  <li v-for="c in item.certifications" :key="c.id" class="unstyled">
                      <v-chip text-color="white" color="grey">{{ c.certification_type }}</v-chip>
                      Expires {{ c.expiration_date | moment("MM/DD/YYYY") }}
                      <v-chip :color="certExpiresColor(c)" text-color="white">{{ certExpiresText(c) }}</v-chip>
                  </li>
                </ul>
              </td>
              <td>
                <v-chip color="error" text-color="white" v-if="!item.last_dosimetry_upload">
                  No record!
                </v-chip>
                <v-chip v-else :color="dosimetryAgeColor(item.last_dosimetry_upload)" text-color="white">{{ Math.abs(dosimetryDaysAgo(item.last_dosimetry_upload)) }} days ago</v-chip>
                {{ item.last_dosimetry_upload | moment("MM/DD/YYYY") }}
              </td>
            </tr>
          </template>
        </v-data-table>
        </v-card>

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  // import {ExportToCsv} from 'export-to-csv';
  import EmployeeName from '@/components/hr/employee-name.vue'

  export default {
    components: { EmployeeName, },
    computed: {
      ...mapState('userAuth', ['user']),
      //computedOffset: function () {
      //  return this.limit * (this.page - 1)
      //},
      //pageLength: function () {
      //  return Math.ceil(this.queryTotal / this.limit)
      //},
      formattedQuery: function() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          employeeID: this.employeeID,
          worksiteID: this.worksiteID,
          //limit: this.limit,
          //offset: this.computedOffset,
          //page: this.page,
        };
      },

      filteredReport() {
        var rep = this.report
        if (this.onlyExpiredDos) {
          rep = rep.filter((r) => {
            const dos = this.$moment(r.last_dosimetry_upload)
            if (r.last_dosimetry_upload == null) {
              return r
            }
            if (dos.isBefore(this.$moment())) {
              return r
            }
          })
        }

        if (this.onlyExpiredCert) {
          rep = rep.filter((r) => {
            console.log(r)
            if (
              r.certifications.filter((c) => {
                return this.$moment(c.expiration_date).isBefore(this.$moment())
              }).length > 0
            ) {
              return r
            }
          })
        }

        return rep
      }
    },
    created() {
      this.setUp();
    },
    watch: {
      onlyExpiredDos(val) {
        if (val) {
          this.onlyExpiredCert = false
        }
      },
      onlyExpiredCert(val) {
        if (val) {
          this.onlyExpiredDos = false
        }
      },
    },
    data: function() {
      return {
        limit: 40,
        page: 1,
        startDateMenu: false,
        endDateMenu: false,
        startDate: this.$moment()
          .subtract(2, 'weeks')
          .format('YYYY-MM-DD'),
        endDate: this.$moment()
          .subtract(1, 'weeks')
          .format('YYYY-MM-DD'),
        reportsPending: true,
        loadingCsv: false,
        report: {},
        onlyExpiredDos: false,
        onlyExpiredCert: false,
        employeeID: null,
        worksiteID: null,
        //defaultSort: {
        //  sortBy: 'order',
        //  rowsPerPage: -1, //all
        //},
        headers: [
          { text: 'Employee', value: 'last_name', sortable: true },
          { text: 'Certifications', value: 'certifications', sortable: false },
          { text: 'Dosimetry Upload', value: '', sortable: false },
        ],
      };
    },

    methods: {
      setUp: function() {
        //this.startDate = this.$route.query.startDate || this.startDate;
        //this.endDate = this.$route.query.endDate || this.endDate;
        //this.employeeID = this.$route.query.employeeID || this.employeeID;
        //this.worksiteID = this.$route.query.worksiteID || this.worksiteID;

        this.getReports();
      },

      dosimetryDaysAgo(date) {
        return this.$moment().diff(date, "days")
      },

      dosimetryAgeColor(date) {
        const daysAgo = this.dosimetryDaysAgo(date)
        if (daysAgo > 60) {
          return "error"
        }

        if (daysAgo > 30) {
          return "warning"
        }

        return "primary"
      },

      certExpiresColor(cert) {
        const expDate = this.$moment(cert.expiration_date)

        //const diff = this.$moment().diff(expDate, "days")
        const diff = expDate.diff(this.$moment(), "days")

        if (expDate.isBefore(this.$moment())) {
          return "error"
        } else {
          if (diff > 60) {
            return "grey"
          }
          if (diff > 30) {
            return "warning"
          }
          if (diff < 30) {
            return "error"
          }
        }
      },

      certExpiresText(cert) {
        const expDate = this.$moment(cert.expiration_date)
        const diff = expDate.diff(this.$moment(), "days")

        if (expDate.isBefore(this.$moment())) {
          return `${ Math.abs(diff) } days ago`
        } else {
          if (diff > 60) {
            return "Not expiring soon"
          }
          if (diff > 30) {
            return `Next month`
          }
          if (diff < 30) {
            return `In ${ diff } days`
          }
        }


      },

      dateFormatted: function(date) {
        return date ? this.$moment(date).format('dddd, MMMM D') : '';
      },

      getReports: function() {
        this.reportsPending = true;
        this.$store
          .dispatch('reports/getCertificationsReport')
          .then(report => {
            console.log(report)
            this.report = report
          })
          .catch(err => {
            console.log(err);
          })
          .finally(res => {
            this.reportsPending = false;
          });
      },
      reGetRecords: function() {
        this.getReports()
      },
    },
  };
</script>
